import React from 'react'
import PropTypes from 'prop-types'
import AdvertisingProduct from './AdvertisingProduct'
import DigitalPlanDrawingProduct from './DigitalPlanDrawingProduct'
import DigitalRetouchedFurnishingPhotoProduct from './DigitalRetouchedFurnishingPhotoProduct'
import DigitalRetouchedRenovationPhotoProduct from './DigitalRetouchedRenovationPhotoProduct'
import DronePhotoProduct from './DronePhotoProduct'
import DronePremiumPhotoProduct from './DronePremiumPhotoProduct'
import EdgePhotoProduct from './EdgePhotoProduct'
import ElevatedPhotoProduct from './ElevatedPhotoProduct'
import EveningPhotoProduct from './EveningPhotoProduct'
import ExclusivePhotoProduct from './ExclusivePhotoProduct'
import FacadePhotoProduct from './FacadePhotoProduct'
import FloorPlansProduct from './FloorPlansProduct'
import LocalAreaPhotoProduct from './LocalAreaPhotoProduct'
import MastPremiumPhotoProduct from './MastPremiumPhotoProduct'
import PanoramaPhotoProduct from './PanoramaPhotoProduct'
import PlanDrawingProduct from './PlanDrawingProduct'
import PortraitPhotoProduct from './PortraitPhotoProduct'
import PremiumHighPhotoProduct from './PremiumHighPhotoProduct'
import PremiumPhotoProduct from './PremiumPhotoProduct'
import PrePhotoProduct from './PrePhotoProduct'
import RetouchedEveningPhotoProduct from './RetouchedEveningPhotoProduct'
import StandardPhotoProduct from './StandardPhotoProduct'
import StylingProduct from './StylingProduct'
import VideoProduct from './VideoProduct'
import WalkthroughProduct from './WalkthroughProduct'

const Forms = {
  AdvertisingProduct,
  DigitalPlanDrawingProduct,
  DigitalRetouchedFurnishingPhotoProduct,
  DigitalRetouchedRenovationPhotoProduct,
  DronePhotoProduct,
  DronePremiumPhotoProduct,
  EdgePhotoProduct,
  ElevatedPhotoProduct,
  EveningPhotoProduct,
  ExclusivePhotoProduct,
  FacadePhotoProduct,
  FloorPlansProduct,
  LocalAreaPhotoProduct,
  MastPremiumPhotoProduct,
  PanoramaPhotoProduct,
  PlanDrawingProduct,
  PortraitPhotoProduct,
  PremiumHighPhotoProduct,
  PremiumPhotoProduct,
  PrePhotoProduct,
  RetouchedEveningPhotoProduct,
  StandardPhotoProduct,
  StylingProduct,
  VideoProduct,
  WalkthroughProduct,
}

const ProductForm = (props) => {
  const onChange = (data) => {
    if (props.onChange) {
      props.onChange(data)
    }
  }

  const FormComponent = Forms[props.product.__typename]

  if (FormComponent) {
    return (
      <FormComponent
        product={props.product}
        bundleProduct={props.bundleProduct}
        webOrder={props.webOrder}
        onChange={onChange}
        productAvailability={props.productAvailability}
      />
    )
  }

  return null
}

ProductForm.productTypeHasFormComponent = (type) => {
  return type in Forms
}

ProductForm.propTypes = {
  product: PropTypes.object.isRequired,
  webOrder: PropTypes.object.isRequired,
  productAvailability: PropTypes.object.isRequired,
  bundleProduct: PropTypes.object,
  onChange: PropTypes.func,
}

export default ProductForm
